/**
 * SECURITY: markdown-it ReDoS mitigation (GHSA-38c4-r59v-3vqw)
 *
 * Prevents catastrophic backtracking in markdown-it parser by:
 * 1. Capping input length
 * 2. Collapsing deeply nested patterns that trigger exponential regex behavior
 *
 * Do NOT remove without verifying markdown-it has been patched upstream.
 * See: https://github.com/advisories/GHSA-38c4-r59v-3vqw
 */
export const sanitizeMarkdown = (text: string, maxLength = 10_000): string => {
	if (!text) return '';
	const truncated = text.length > maxLength ? text.slice(0, maxLength) : text;
	return truncated
		.replace(/(\*{3,})/g, '**')
		.replace(/(_{3,})/g, '__')
		.replace(/(~{3,})/g, '~~')
		.replace(/(\[){5,}/g, '[[[[')
		.replace(/(\]){5,}/g, ']]]]');
};
